export class LoginParam {
    username!: string
    password?: string


    twoFactorCode?: string
    sessionToken?: string
    tenantIdentifier?: string
}
export class SwitchTenantParam {
    tenantId: string
    /**
     *
     */
    constructor(tn: string) {
        this.tenantId = tn;


    }
}